import { useTranslation } from '@/contexts/i18n-context';
import styles from './styles.module.css';
import clsx from 'clsx';

export interface SvgProps {
  className?: string;
  ariaLabel?: string;
}

export function EmailSvg({ className, ariaLabel }: SvgProps) {
  const { t } = useTranslation();
  return (
    <svg
      role="img"
      aria-label={ariaLabel ?? t('svg.email')}
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="77"
      viewBox="0 0 80 77"
      className={clsx(styles.brand, className)}
    >
      <path d="M56.4004 31.7002H23.5V27.0996H56.4004V31.7002Z" fill="inherit" />
      <path d="M56.4004 23.0996H23.5V18.5H56.4004V23.0996Z" fill="inherit" />
      <path d="M56.4004 14.7002H23.5V10.0996H56.4004V14.7002Z" fill="inherit" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64 18.5996H80V76.6992H78.3789C78.2512 76.7233 78.1178 76.7363 77.9795 76.7363H2.19434C2.05559 76.7363 1.91835 76.7234 1.78418 76.6992H0V18.5996H16V0H64V18.5996ZM41.4316 54.4414C41.0439 54.7704 40.5653 54.9345 40.0869 54.9346C39.6087 54.9345 39.1307 54.7703 38.7432 54.4414L33.9756 50.3916L8.88867 71.6992H71.2861L46.1992 50.3916L41.4316 54.4414ZM49.2881 47.668L75 69.5049V25.8291L49.2881 47.668ZM5 69.4521L30.6504 47.668L5 25.8818V69.4521ZM21 33.8545L40.0869 50.0664L59 34.0029V5H21V33.8545ZM64 29.7568L71.25 23.5996H64V29.7568ZM16 29.6084V23.5996H8.9248L16 29.6084Z"
        fill="inherit"
      />
    </svg>
  );
}
